/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Deactivateall_Confirm3Inputs */

const en_settings_reportingapikeys_deactivateall_confirm3 = /** @type {(inputs: Settings_Reportingapikeys_Deactivateall_Confirm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate all keys`)
};

/**
* | output |
* | --- |
* | "Deactivate all keys" |
*
* @param {Settings_Reportingapikeys_Deactivateall_Confirm3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_deactivateall_confirm3 = /** @type {((inputs?: Settings_Reportingapikeys_Deactivateall_Confirm3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Deactivateall_Confirm3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_deactivateall_confirm3(inputs)
});
export { settings_reportingapikeys_deactivateall_confirm3 as "settings_reportingApiKeys_deactivateAll_confirm" }